import update from '../../utilities/update';
export const loading=(state,action)=>{
    return update(state,{
        loading:true,
        error:null,
        message:null
    })
}

